<template>
  <div>
    <el-row style="line-height: 50px;height: 50px;color:white;" class="cus-sider">
      <el-col :span="1">
        <span class="el-icon-s-grid" style="color:white;font-size:30px;padding:8px;cursor:pointer;" @click="back()"></span>
      </el-col>
      <el-col :span="4" class="align-left">
        <el-popover placement="bottom-start" width="800" trigger="click" v-model="display_sugeries" >
          <div  class="anes-index">
            <el-row class="line-height40">
              <el-col :span="7">
                <item-input type="datearraw2" v-model="rdate" :clearable="false" size="mini"></item-input>
              </el-col>
              <el-col :span="5" class="padding-right10">
                <item-input type="string"  v-model="searchKey" :placeholder="getPlaceholder" :clearable="true" size="mini"></item-input>
              </el-col>
              <!-- <el-col :span="4" class="padding-right10">
                <item-input type="multiselect"   size="mini" v-model="surgery_status" :options="sys_enums&&sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
              </el-col> -->
              <el-col :span="5" class="padding-right10">
                <item-input type="select" size="mini" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
              </el-col>
              <el-col :span="4">
                <div class="align-left"><item-input type="checkbox"  v-model="is_own" >我的患者</item-input></div>
              </el-col>
            </el-row>
            <el-scrollbar class="height500">
              <el-row  v-if="surgeries&&surgeries.length>0">
                <el-col v-for="p in surgeries" :key="p.id" :span="12" class="padding5" >
                  <el-row  class="padding5 patient-card" >
                    <el-col :span="1" class="height-p100">
                      <div class="surgery-status-tag2" :class="p.enum_surgery_status==30?'bg-danger':p.enum_surgery_status==20||p.enum_surgery_status==10?'bg-primary' :'bg-info'"></div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v">
                      <div @click="routeToPatient(p)">{{`${p.patient_name}(${p.sex||'--'}/${p.age||'--'}/${p.visit_no||'--'}/${p.dic_section} ${p.bed_no||'--'}床)`}}</div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <p v-else class="no-surgery">暂无手术</p>
            </el-scrollbar>
          </div>
          <el-button slot="reference" style="background:whitesmoke;">
            <!-- <span class="fg-info">患者：</span> -->
            <b>{{activeSurgery.patient_name}}</b>({{activeSurgery.age||'--'}}
            /{{activeSurgery.visit_no||'--'}}/{{activeSurgery.bed_no||'--'}}床)
            <el-tag :type="activeSurgery.enum_surgery_type==1?'danger':'primary'" size="mini" v-if="activeSurgery.enum_surgery_type">{{activeSurgery.surgery_type}}</el-tag>
          </el-button>
        </el-popover>
      </el-col>
      <el-col :span="2">
        <span class="fg-info">病区：</span><b>{{activeSurgery.dic_section}}</b>
      </el-col>
      <el-col :span="4" class="padding5 padding-none-v align-left">
        <span class="ellipsis"><span class="fg-info">手术：</span><b>{{activeSurgery.diseases}}</b></span>
      </el-col>
      <el-col :span="3" class="align-left">
        <span class="fg-info">注意事项：</span>
        <b class="fg-warning">{{activeSurgery.emergency||'无'}}</b>
      </el-col>
      <el-col :span="4" class="align-left">
        <span class="fg-info">麻醉方式：</span>
        <b class="fg-danger">{{activeSurgery.emergency||''}}</b>
      </el-col>
      <el-col :span="3" class="align-left">
        <span class="fg-info">手术时间：</span>
        <b>{{activeSurgery.apply_time&&$moment(activeSurgery.apply_time).format('MM/DD HH:MM')||''}}</b>
      </el-col>
      <el-col :span="2" class="align-left">
        <span class="fg-info">手术状态：</span>
        <b class="fg-danger">{{activeSurgery.surgery_status||''}}</b>
      </el-col>
    </el-row>
    <div style="height: 35px;">
      <ScrollPane style="height: 35px;">
        <tree-menu :data="_menu" mode="horizontal"></tree-menu>
      </ScrollPane>
    </div>
    <el-scrollbar :style="{height:(this.screenHeight-78)+'px'}">
      <router-view  v-if="isReloadAlive"></router-view>
      <!-- <div style="margin:10px 20px 10px 10px;">
        <keep-alive>
        </keep-alive>
      </div> -->
    </el-scrollbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
function switchToTree(root, menus) {
    return _.orderBy(root, `display_order`).map((r) => {
        let children = _.filter(menus, { parent_id: r.id })
        let parent = _.filter(menus, { id: r.parent_id })
        if (!_.startsWith(r.url, `/`)) {
            r.url = (parent && parent[0] && parent[0].url) + `/` + r.url
        }
        return {
            index: r.index,
            route: { path: `${r.url}` },
            label: r.name,
            icon: r.icon,
            path: r.url,
            permission: `default`,
            children: children.length > 0 ? switchToTree(children, menus) : []
        }
    })
}
export default {
    provide() {
        return {
            reload: this.reload
        }
    },
    name: `AnesthesiaIndex`,
    components: {
    },
    data() {
        return {
            enable_tagsview: true,
            searchKey: ``,
            activeSurgeryId: this.$route.query.surgery_id,
            activeNames: [],
            isReloadAlive: true,
            surgeries: [],
            rdate: this.$moment().format(`YYYY/MM/DD`),
            dic_room_id: undefined,
            surgery_status: [20], // 20
            is_own: false,
            display_sugeries: false
        }
    },
    created() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadSurgery().then(data => { // 根据手术id获取当天手术列表
            this.rdate = data.plan_time && this.$moment(data.plan_time).format(`YYYY/MM/DD`) || this.$moment().format(`YYYY/MM/DD`)
            this.loadSurgeries().then(() => {
                this.cus_collapse_item_active(this.activeSurgeryId)
            })
        })
    },
    mounted() {
        // const that = this
        // that.$store.dispatch("/permission/ADD_PERMISSIONS")

    },
    computed: {
        ...mapGetters([`screenHeight`, `permissions`, `workbar`, `operation_ward_auth`, `sys_enums`, `active_ward`, `business`]),
        collapse() {
            return this[`layout/collapse`]
        },
        getPlaceholder() {
            return `${this.T(`surgery.visit_no`)}/患者姓名`
        },
        menu() {
        // let root = _.filter(this.permissions, { no: 'surgery' })
            let workbarid = this.$route.meta.workbar
            let wf = _.find(this.workbar, { id: workbarid })
            if (!(wf && wf.menu_models)) return []
            let allid = wf.menu_models.map(ar => ar.id)
            let root = _.filter(wf.menu_models, function(r) {
                return _.indexOf(allid, r.parent_id) == -1
            })
            let r = switchToTree(root, wf.menu_models)
            return r.length == 0 ? [] : r.length > 1 ? r : r[0].children
        },
        _menu() {
            let _m = this.menu.map(m => {
                let r = _.cloneDeep(m)
                r.route = { path: `${m.route.path}`, query: { surgery_id: this.activeSurgeryId } }
                return r
            })
            return _m
        },
        _surgeries() {
            let r = _.filter(this.surgeries, d => {
                let sk = this.searchKey.toUpperCase()
                let result = true
                if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    result = `ow_${d.dic_operating_ward_id}` == this.active_ward.value
                }
                if (result && this.is_own) {
                    result = d.is_own_data_auth_filter
                }
                if (result && sk.length > 0) {
                    result = d.patient_abbr.toUpperCase().indexOf(sk) > -1 || d.patient_name.toUpperCase().indexOf(sk) > -1 || d.visit_no.toUpperCase().indexOf(sk) > -1
                }
                if (result && this.dic_room_id) {
                    result = d.dic_operating_room_id == this.dic_room_id
                }
                return result
            })

            return _.orderBy(r, [`dic_operating_room_id`], [`asc`])
        },
        activeSurgery() {
            return _.find(this.surgeries, { id: this.activeSurgeryId * 1 }) || {}
        },
        operationRoom() {
            return this.active_ward && this.active_ward.operation_room.map(d => {
                d.code = ``
                return d
            }) || []
        },
        displayOperationRoomFilter() {
            return this.active_ward && this.active_ward.operation_room
        },
        anes_list_path() {
            let r = _.find(this.business, { business_level: `M001` })
            return r && r.url || `/`
        },
        anesthesia_path() {
            let r = _.find(this.business, { business_level: `M002` })
            return r && r.url || `/`
        }
    },
    methods: {
        getFirstLetter(str) {
            return _.first(str) + `*` + _.last(str)
        },
        cus_collapse_item_active(surgeryId) {
            this.activeSurgeryId = surgeryId
            let { name, query } = this.$route
            if (surgeryId > 0 && query && query.surgery_id !== surgeryId) {
                let t = _.find(this.menu, [`index`, name]) || this.menu[0]
                this.$router.push({ path: t.path, query: { surgery_id: surgeryId } })
            }
        },
        loadSurgeries() {
            // 更改日期触发更新列表
            return new Promise((resolve) => {
                let req = this.myaxios.post(`/api/Operation/Home/GetPatientList?date=${this.rdate}`, this.surgery_status)
                req.then(data => {
                    let r = _.filter(data, d => {
                        let sk = this.searchKey.toUpperCase()
                        let result = true
                        // if(this.active_ward&&_.startsWith(this.active_ward.value,'ow_')){
                        //   result = `ow_${d.dic_operating_ward_id}`==this.active_ward.value
                        // }
                        if (result && this.is_own) {
                            result = d.is_own_data_auth_filter
                        }
                        if (result && sk.length > 0) {
                            result = d.patient_abbr.toUpperCase().indexOf(sk) > -1 || d.patient_name.toUpperCase().indexOf(sk) > -1 || d.visit_no.toUpperCase().indexOf(sk) > -1
                        }
                        if (result && this.dic_room_id) {
                            result = d.dic_operating_room_id == this.dic_room_id
                        }
                        return result
                    })
                    this.surgeries = r
                    if (!this.activeSurgeryId) {
                        this.activeSurgeryId = r && r[0] && r[0].id
                    }
                    resolve(r)
                }).catch(e => {
                    this.surgeries = []
                    resolve([])
                })
            })
        },
        loadSurgery() {
            if (this.activeSurgeryId) {
                return this.myaxios.get(`/api/Preoperative/Apply/Get/${this.activeSurgeryId}`)
            } else {
                return Promise.resolve({})
            }
        },
        reload() {
            this.isReloadAlive = false
            this.$nextTick(() => (this.isReloadAlive = true))
        },
        back() { // 返回麻醉列表
            this.$router.push(this.anes_list_path)
        },
        routeToPatient(p) {
            let q = Object.assign({ ...this.$route.query }, { surgery_id: p.id })
            this.display_sugeries = false
            this.$router.push({ path: this.$route.path, query: q })
        }
    },
    watch: {
        rdate: function() {
            this.loadSurgeries()
        },
        surgery_status: function() {
            this.loadSurgeries()
        },
        active_ward: function() {
            this.dic_room_id = undefined
        },
        $route: function(newUrl, oldUrl) {
            this.activeSurgeryId = newUrl.query.surgery_id
        }
    }
}
</script>
<style scoped lang="less">
  .sub-menu {
    height: 35px;
    /*background: #fff;*/
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    color:#A1AAAC;
    .p_name
  {
    color:#3C4758;
  }
  .el-col
  {
    &:first-of-type{
      line-height:35px;
    }
  }
  }
  .el-icon-search {
    color: red;
    cursor: pointer;
    &:hover
    {
      color: whitesmoke;
    }
  }
</style>
<style lang="less">
.surgery-status-tag2{
  width:10px;
  height: 10px;
  border-radius: 50%;
  margin-top:4px;
}
.anes-index .patient-card{
  background:whitesmoke;
  cursor: pointer;
  &:hover{
    background:lightgray;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/Index.vue